// Site-wide CTA is unified: this re-exports the homepage CTA so every page that
// renders <CtaSection /> shows the same component. Edit it in one place:
// src/components/sections/home/cta/index.tsx
export { default } from "@/components/sections/home/cta";
